<template>
	<svg width="15" height="22" viewBox="0 0 15 22" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path d="M9.24599 8.99994H13.1989C14.0056 8.99994 14.4803 9.90591 14.0211 10.5691L6.10761 21.9999L6.91337 15.1162C6.98294 14.5219 6.51852 13.9999 5.92016 13.9999H1.95282C1.15887 13.9999 0.681546 13.1192 1.11501 12.454L9.1002 0.199951L8.25202 7.89031C8.18671 8.48241 8.6503 8.99994 9.24599 8.99994Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
